import { useContext } from 'react';
import { ScenarioStatesProviderContext } from '../providers/StatesProvider';

const useThermalHeatmap = () => {
    const context = useContext(ScenarioStatesProviderContext);
    if (context === undefined) {
        throw new Error('useThermalHeatmap must be used within a StatesProvider');
    }
    // Extract thermal data for the currently selected group
    const selectedGroupId = context.selectedGroupSatellite?.groupId;
    const groupThermalData = selectedGroupId && context.thermalHeatmapData
        ? context.thermalHeatmapData[selectedGroupId]
        : null;

    return {
        isThermalOpen: context.isThermalOpen,
        setIsThermalOpen: context.setIsThermalOpen,
        thermalHeatmapData: groupThermalData,
        thermalEnvParams: context.thermalEnvParams,
        thermalModel: context.thermalModel,
        orbitalInsights: context.formData.assets.orbitalInsights.data,
        scenarioResponse: context.scenarioResponse,
        selectedGroupSatellite: context.selectedGroupSatellite,
    };
};

export default useThermalHeatmap;
